import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button } from 'Components';
import { EditUserValues } from 'Pages/User/User.types';

const SaveButton = ({ saveChanges }: { saveChanges: () => void }) => {
	const { t } = useTranslation();
	const {
		isValid,
		dirty,
		isSubmitting
	} = useFormikContext<EditUserValues>();
	const disabled = !(isValid && dirty);

	const handleSubmit = () => {
		saveChanges();
	};

	return (
		<div className="btn-footer">
			<Button
				shape="round"
				type="primary"
				disabled={disabled}
				loading={isSubmitting}
				onClick={handleSubmit}
				className={disabled ? 'cta-disabled' : ''}
			>
				{t(`saveChanges`)}
			</Button>
		</div>
	);
};

export default SaveButton;
